var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-column", staticStyle: { gap: "20px" } },
    [_c(_setup.Form), _c(_setup.Index, { ref: "attendanceSheetIndexRef" })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }